import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { ConversationList } from '../components/conversations/ConversationList';
import { UnifiedThread } from '../components/conversations/UnifiedThread';
import { WhatsAppAnalytics } from '../components/whatsapp/WhatsAppAnalytics';
import { WhatsAppLead, UnifiedMessage } from '../types/whatsapp';
import { MessageSquareIcon, BarChart2Icon } from 'lucide-react';
// Mock Data
const MOCK_LEADS: WhatsAppLead[] = [{
  id: 1,
  name: 'Rahul Sharma',
  phone: '+91 9876543210',
  source: 'whatsapp',
  lastMessage: 'Is the test drive available tomorrow?',
  lastMessageTime: '10:30 AM',
  unreadCount: 2,
  aiScore: 85,
  status: 'active',
  tags: ['Hot Lead'],
  carModel: 'Scorpio-N',
  dealer: 'Mumbai Motors'
}, {
  id: 2,
  name: 'Priya Patel',
  phone: '+91 9876543211',
  source: 'web',
  lastMessage: 'Thanks for the brochure.',
  lastMessageTime: 'Yesterday',
  unreadCount: 0,
  aiScore: 65,
  status: 'active',
  tags: ['Warm Lead'],
  carModel: 'XUV700',
  dealer: 'Delhi Auto Hub'
}, {
  id: 3,
  name: 'Amit Kumar',
  phone: '+91 9876543212',
  source: 'referral',
  lastMessage: 'Missed call',
  lastMessageTime: 'Yesterday',
  unreadCount: 1,
  aiScore: 45,
  status: 'dormant',
  tags: [],
  carModel: 'Thar',
  dealer: 'Pune Motors'
}];
const MOCK_MESSAGES: UnifiedMessage[] = [{
  id: '1',
  content: 'Lead assigned to dealer',
  timestamp: 'Yesterday 9:00 AM',
  from: 'system',
  status: 'completed',
  type: 'event',
  channel: 'system'
}, {
  id: '2',
  content: 'Hi Rahul, thanks for your interest in Scorpio-N. Here is the brochure.',
  timestamp: 'Yesterday 9:05 AM',
  from: 'bot',
  status: 'read',
  type: 'document',
  channel: 'auto-trigger'
}, {
  id: '3',
  content: 'Thanks! Can I schedule a test drive?',
  timestamp: 'Yesterday 10:15 AM',
  from: 'customer',
  status: 'read',
  type: 'text',
  channel: 'whatsapp'
}, {
  id: '4',
  content: 'Tried calling you',
  timestamp: 'Yesterday 2:30 PM',
  from: 'dealer',
  status: 'missed',
  type: 'call',
  channel: 'voice',
  metadata: {
    callDuration: '0:00'
  }
}, {
  id: '5',
  content: 'Is the test drive available tomorrow?',
  timestamp: '10:30 AM',
  from: 'customer',
  status: 'delivered',
  type: 'text',
  channel: 'whatsapp'
}];
export function Conversations() {
  const [activeTab, setActiveTab] = useState<'inbox' | 'analytics'>('inbox');
  const [selectedLead, setSelectedLead] = useState<WhatsAppLead>(MOCK_LEADS[0]);
  const [messages, setMessages] = useState<UnifiedMessage[]>(MOCK_MESSAGES);
  const handleSendMessage = (content: string, channel: any) => {
    const newMessage: UnifiedMessage = {
      id: Date.now().toString(),
      content,
      timestamp: 'Just now',
      from: 'dealer',
      status: 'sent',
      type: 'text',
      channel
    };
    setMessages([...messages, newMessage]);
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-946">
      <Sidebar data-id="element-947" />
      <main className="flex-1 flex flex-col h-screen overflow-hidden" data-id="element-948">
        <Header data-id="element-949" />

        {/* Tab Navigation */}
        <div className="bg-white border-b border-gray-200 px-6 pt-4" data-id="element-950">
          <div className="flex space-x-6" data-id="element-951">
            <button onClick={() => setActiveTab('inbox')} className={`flex items-center pb-4 text-sm font-medium border-b-2 transition-colors ${activeTab === 'inbox' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-952">
              <MessageSquareIcon size={18} className="mr-2" data-id="element-953" />
              Unified Inbox
            </button>
            <button onClick={() => setActiveTab('analytics')} className={`flex items-center pb-4 text-sm font-medium border-b-2 transition-colors ${activeTab === 'analytics' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-954">
              <BarChart2Icon size={18} className="mr-2" data-id="element-955" />
              Analytics & Insights
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-hidden" data-id="element-956">
          {activeTab === 'inbox' ? <div className="flex h-full" data-id="element-957">
              <ConversationList leads={MOCK_LEADS} selectedLeadId={selectedLead.id} onSelectLead={setSelectedLead} data-id="element-958" />
              <div className="flex-1 h-full" data-id="element-959">
                <UnifiedThread lead={selectedLead} messages={messages} onSendMessage={handleSendMessage} data-id="element-960" />
              </div>
              {/* Optional Right Sidebar for Lead Details could go here */}
            </div> : <div className="h-full overflow-y-auto p-6" data-id="element-961">
              <WhatsAppAnalytics data-id="element-962" />
            </div>}
        </div>
      </main>
    </div>;
}